import * as XLSX from 'xlsx'

/**
 * Trigger a real .xlsx download in the browser from an array of plain row objects.
 * Purely client-side (SheetJS writeFile) — no backend/API call. Column headers are the
 * object keys of the first row.
 */
export function downloadRowsAsXlsx(filename, rows, sheetName = 'Sheet1') {
  const data = rows && rows.length ? rows : [{ '': 'No data' }]
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, String(sheetName).slice(0, 31))
  XLSX.writeFile(wb, filename)
}
